
/**
 * Language codes mapping
 */
export const languageCodes: Record<string, string> = {
  afrikaans: 'af',
  albanian: 'sq',
  amharic: 'am',
  arabic: 'ar',
  armenian: 'hy',
  assamese: 'as',
  azerbaijani_cyrillic: 'az-Cryl-AZ',
  azerbaijani_latin: 'az-Latn-AZ',
  belarusian: 'be',
  bengali: 'bn',
  bosnian: 'bs',
  bulgarian: 'bg',
  burmese: 'my',
  catalan: 'ca',
  chinese_simplified: 'zh-Hans',
  chinese_traditional: 'zh-Hant',
  croatian: 'hr',
  czech: 'cs',
  danish: 'da',
  dari: 'prs',
  dutch: 'nl',
  english: 'en',
  estonian: 'et',
  fijian: 'fj',
  filipino: 'fil',
  finnish: 'fi',
  french: 'fr',
  french_canada: 'fr-CA',
  galician: 'gl',
  georgian: 'ka',
  german: 'de',
  greek: 'el',
  gujarati: 'gu',
  haitian: 'ht',
  hausa: 'ha',
  hebrew: 'he',
  hindi: 'hi',
  hmong: 'hmn',
  hungarian: 'hu',
  icelandic: 'is',
  igbo: 'ig',
  indonesian: 'id',
  irish: 'ga',
  isixhosa: 'xh',
  italian: 'it',
  japanese: 'ja',
  kannada: 'kn',
  kazakh: 'kk',
  khmer: 'km',
  kinyarwanda: 'rw',
  kinyarwanda_rwanda: 'rw_RW',
  korean: 'ko',
  kyrgyz: 'ky',
  lao: 'lo',
  latvian: 'lv',
  lithuanian: 'lt',
  luxembourgish: 'lb',
  macedonian: 'mk-MK',
  malagasy: 'mg',
  malay: 'ms',
  malayalam: 'ml',
  maltese: 'mt',
  maori: 'mi',
  marathi: 'mr',
  mongolian: 'mn',
  nepali: 'ne',
  norwegian: 'no',
  oriya: 'or',
  pashto: 'ps',
  persian: 'fa',
  polish: 'pl',
  portuguese_brazil: 'pt-BR',
  portuguese_portugal: 'pt-PT',
  punjabi: 'pa',
  romanian: 'ro',
  russian: 'ru',
  serbian: 'sr',
  sesotho: 'st',
  shona: 'sn',
  sinhala: 'si',
  slovak: 'sk',
  slovenian: 'sl',
  somali: 'so',
  spanish_latin_america: 'es-419',
  spanish_spain: 'es-ES',
  swahili: 'sw',
  swedish: 'sv',
  tagalog: 'tl',
  tajik: 'tg',
  tamil: 'ta',
  tatar: 'tt',
  telugu: 'te',
  thai: 'th',
  tibetan: 'bo',
  tigrinya: 'ti',
  turkish: 'tr',
  turkmen: 'tk',
  ukrainian: 'uk',
  urdu: 'ur',
  vietnamese: 'vi',
  welsh: 'cy',
  yoruba: 'yo',
  zulu: 'zu'
};
